const flankSignUpValidators = {};

export default flankSignUpValidators;
